import { cn } from 'DesignSystem/utils';
import { formatNumber } from 'utils/helpers';

import { DOH_HEALTH, getDohHealthBand } from './event-items-doh';

export function QohCell({ value }: { value: number | null | undefined }) {
  if (typeof value !== 'number') return <>–</>;

  return (
    <>
      {formatNumber(value)} <span className="ml-1 text-muted-foreground">EA</span>
    </>
  );
}

export function DohCell({ value }: { value: number | null | undefined }) {
  if (typeof value !== 'number') return <>–</>;

  const rounded = Math.round(value);
  const band = getDohHealthBand(rounded);

  return (
    <span className="inline-flex items-center justify-end gap-1.5">
      <span
        data-testid="doh-health-dot"
        className={cn('size-2 shrink-0 rounded-full', DOH_HEALTH[band].dotClassName)}
      />
      <span className="sr-only">{DOH_HEALTH[band].indicatorLabel}</span>
      {formatNumber(rounded)} <span className="ml-1 text-muted-foreground">d</span>
    </span>
  );
}
